import React, { useEffect, useState } from "react";
import GoogleAuth from "../GoogleAuth/GoogleAuth";

const Profile=()=>{

    const [proaddictiveUser,setProaddictiveUser] = useState(JSON.parse(sessionStorage.getItem("proaddictive-user"))||JSON.parse(localStorage.getItem("proaddictive-user")));
    const [token,setToken]=useState(JSON.parse(sessionStorage.getItem("bearer-token"))||JSON.parse(localStorage.getItem("bearer-token")));

    useEffect(()=>{
        if(proaddictiveUser!=null){
            localStorage.setItem("proaddictive-user",JSON.stringify(proaddictiveUser));
            sessionStorage.setItem("proaddictive-user",JSON.stringify(proaddictiveUser));
        }
        if(token!=null){
            localStorage.setItem("bearer-token",JSON.stringify(token));
            sessionStorage.setItem("bearer-token",JSON.stringify(token));
        }
    },[proaddictiveUser,token])

    const logout =()=> {
       sessionStorage.clear();
       localStorage.clear();
       setProaddictiveUser(null);
       setToken(null);
    }

    const Styles = {
        btnLogin:{
            padding:"7px",
            border:"3px solid #EEEEEE",
            background:"#00ADB5",
            color:"#EEEEEE",
            marginLeft:"10px",
            borderRadius:"10px"
        },
        btnLogout:{
            padding:"7px",
            border:"3px solid #EEEEEE",
            background:"#FF2E63",
            color:"#EEEEEE",
            marginLeft:"10px",
            borderRadius:"10px"
        }
    }

    return <div>
        {
            proaddictiveUser?(
                <div>
                    <p style={{marginTop:"5px",marginBottom:"15px"}}>{proaddictiveUser.email}</p>
                    <button onClick={logout} style={Styles.btnLogout}>Logout</button>
                </div>
            ):(
                <GoogleAuth setProaddictiveUser={setProaddictiveUser} setToken={setToken}></GoogleAuth>
            )
        }
    </div>
}

export default Profile;